import dev from "./config.dev.js";
import prod from "./config.prod.js";

// Set by the server in templates/partials/common_head.html
const appEnv = document.querySelector('meta[name="app-env"]')?.content;

export default appEnv === "prod" ? prod : dev;
